"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _browserHelpers = require("@flowio/browser-helpers");

var _utilities = require("../utilities");

// @ts-check

/** @typedef {import('../types').CountryOption} CountryOption */

/** @typedef {import('../types').DropdownOptions} DropdownOptions */

/** @typedef {import('../types').DropdownOptionConfig} DropdownOptionConfig */

/** @typedef {import('../types').CountryPickerOptions} CountryPickerOptions */

/** @typedef {import('../types').CountryFlagImageHTMLOptions} CountryFlagImageHTMLOptions */

/** @typedef {import('../types').FlowWindow} FlowWindow */

/** @typedef {io.flow.internal.v0.models.BrowserBundle} BrowserBundle */
var CountryPickerModal = /*#__PURE__*/function () {
  (0, _createClass2["default"])(CountryPickerModal, null, [{
    key: "create",

    /** @type {CountryPickerOptions} */
    // eslint-disable-next-line max-len

    /** @type {(optionsObj: CountryPickerOptions) => Promise<any>} */
    value: function create(optionsObj) {
      var instance = new CountryPickerModal(optionsObj);
      instance.initDomElements();
      instance.createCountryPickerModal();
      return Promise.resolve(instance);
    }
    /**
     * @param {CountryPickerOptions} optionsObj
     */

  }]);

  function CountryPickerModal(optionsObj) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, CountryPickerModal);
    (0, _defineProperty2["default"])(this, "options", void 0);
    (0, _defineProperty2["default"])(this, "toggleModal", function (currentExperience) {
      var modalBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (!modalBody) {
        _this.container.removeChild(_this.modal);

        _this.container.removeChild(_this.backdrop);

        (0, _browserHelpers.removeEvent)(_this.backdrop, 'click', _this.toggleModal);
        (0, _browserHelpers.removeEvent)(_this.modalCloseIcon, 'click', _this.toggleModal);
        (0, _utilities.removeChildren)(_this.modal);
      } else {
        var header = document.createElement('div');
        (0, _browserHelpers.addEvent)(_this.backdrop, 'click', _this.toggleModal);
        (0, _browserHelpers.addEvent)(_this.modalCloseIcon, 'click', _this.toggleModal);
        header.innerHTML = "\n        <div class=\"flow-country-picker-modal-header\">\n          <div class=\"flow-country-picker-modal-title-container\">\n            <span class=\"flow-country-picker-modal-title\">".concat(title, "</span>\n          </div>\n        </div>\n      ");
        header.getElementsByClassName('flow-country-picker-modal-title-container')[0].appendChild(_this.modalCloseIcon);

        _this.modal.appendChild(header);

        _this.modal.appendChild(modalBody);

        _this.container.appendChild(_this.modal);

        _this.container.appendChild(_this.backdrop);
      }
    });
    (0, _defineProperty2["default"])(this, "generateModalOptions", function (options) {
      var countries = options.countries;
      var modalBody = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-modal-body'
      });
      var modalBodyContent = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-modal-body-content'
      });
      countries.forEach(function (country) {
        var label = country.label ? country.label : _this.options.labelFormatter(country);
        var modalItem = document.createElement('div');
        modalItem.innerHTML = "\n        <div class=\"flow-country-picker-modal-item\">\n          ".concat((0, _utilities.getCountryFlagImageHTML)(country.iso_3166_2, _this.options.logo, country.name, {
          imgSrc: country.logoUrl,
          className: 'flow-country-picker-modal-logo'
        }), "\n          <span class=\"flow-country-picker-modal-text\">").concat(label, "</span>\n        </div>\n      ");
        (0, _browserHelpers.addEvent)(modalItem, 'click', function () {
          // Changes the trigger label and the selected item in the modal
          _this.modalTrigger.innerHTML = "\n          ".concat((0, _utilities.getCountryFlagImageHTML)(country.iso_3166_2, _this.options.logo, country.name, {
            imgSrc: country.logoUrl
          }), "\n          <span class=\"flow-country-picker-modal-trigger-text\">").concat(label, "</span>\n        ");

          if (_this.currentlySelectedItem && (0, _browserHelpers.hasClass)(_this.currentlySelectedItem, 'flow-country-picker-selected-modal-item')) {
            (0, _browserHelpers.removeClass)(_this.currentlySelectedItem, 'flow-country-picker-selected-modal-item');
          }

          if (!(0, _browserHelpers.hasClass)(modalItem, 'flow-country-picker-selected-modal-item')) {
            (0, _browserHelpers.addClass)(modalItem, 'flow-country-picker-selected-modal-item');
          }

          _this.currentlySelectedItem = modalItem;

          var sessionPutForm = _this.options.onSelection(country);

          if (sessionPutForm) {
            if (!_this.options) {
              console.error('You cannot use default on selection behaviour when a Flow session does not exist.');
              return;
            }

            (0, _utilities.updateSession)(sessionPutForm, _this.session.id, _this.session.organization, _this.options.onSessionUpdate);
          }
        });

        if (country.name === _this.currentCountry.name && country.currency === _this.currentCountry.currency) {
          modalItem.setAttribute('class', 'flow-country-picker-modal-item-container flow-country-picker-selected-modal-item');
          _this.currentlySelectedItem = modalItem;
        } else {
          modalItem.setAttribute('class', 'flow-country-picker-modal-item-container');
        }

        modalBodyContent.appendChild(modalItem);
      });
      modalBody.appendChild(modalBodyContent);
      (0, _browserHelpers.addEvent)(_this.modalTrigger, 'click', function () {
        return _this.toggleModal(_this.currentCountry, modalBody, _this.options.modalTitle);
      });
    });
    var displayDefaultCurrency = optionsObj.displayDefaultCurrency;
    this.options = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, (0, _utilities.getDefaultCountryPickerOptions)(displayDefaultCurrency)), optionsObj);
    this.instanceId = "countryPickerIsnt_".concat(Math.round(Math.random() * 10000));
  }

  (0, _createClass2["default"])(CountryPickerModal, [{
    key: "initDomElements",
    value: function initDomElements() {
      // Body should always exist
      var body = document.getElementsByTagName('body')[0];

      if (!body) {
        console.error('Could not get body element');
        return;
      }

      this.container = (0, _utilities.createDomElement)('div', {
        id: "".concat(this.instanceId, "_container")
      });
      this.modalTrigger = (0, _utilities.createDomElement)('span', {
        "class": 'flow-country-picker-modal-trigger'
      });
      this.modalCloseIcon = (0, _utilities.createDomElement)('svg', {
        "class": 'flow-country-picker-modal-close',
        xmlns: 'http://www.w3.org/2000/svg',
        viewbox: '0 0 10 10',
        version: '1.1'
      });
      this.modalCloseIcon.innerHTML = "\n      <g stroke-width=\"2px\">\n        <line x1=\"0\" y1=\"0\" x2=\"10\" y2=\"10\"></line>\n        <line x1=\"10\" y1=\"0\" x2=\"0\" y2=\"10\"></line>\n      </g>\n    ";
      this.modal = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-modal',
        id: this.instanceId
      });
      this.backdrop = (0, _utilities.createDomElement)('div', {
        "class": 'flow-country-picker-modal-backdrop',
        id: 'countryPickerBackdrop'
      });
      body.appendChild(this.container);
    }
  }, {
    key: "createCountryPickerModal",
    value: function createCountryPickerModal() {
      this.session = JSON.parse(localStorage.getItem('_f60_session'));
      var countryPicker = document.getElementById(this.options.containerId);

      if (!countryPicker) {
        var errMsg = 'No country picker element detected';
        console.error(errMsg);
        return Promise.reject(new Error(errMsg));
      }

      countryPicker.appendChild(this.modalTrigger);

      if (this.options.currentExperience) {
        this.currentCountry = this.options.currentExperience;
      } else if (this.session) {
        this.currentCountry = (0, _utilities.sessionToCountryObj)(this.session);
      } else {
        this.currentCountry = {
          label: 'Select your country'
        };
      }

      this.modalTrigger.innerHTML = "\n      ".concat((0, _utilities.getCountryFlagImageHTML)(this.currentCountry.iso_3166_2, this.options.logo, this.currentCountry.name, {
        imgSrc: this.currentCountry.logoUrl
      }), "\n      <span class=\"flow-country-picker-modal-trigger-text\">").concat(this.currentCountry.label ? this.currentCountry.label : this.options.labelFormatter(this.currentCountry), "</span>\n    ");
      return (0, _utilities.setUpCountries)(this.options, this.session, this.generateModalOptions.bind(this));
    }
    /**
     * @param {{ countries?: CountryOption[], [key: string]: any}} options
     */

  }]);
  return CountryPickerModal;
}();

exports["default"] = CountryPickerModal;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/lib/modal/country-picker-modal.js
// module id = 304
// module chunks = 0 1